import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
// Import all thumbnail images
import thumbnailAi from "../../assets/thumbnail_ai.png";
import thumbnailBusiness from "../../assets/thumbnail_business.png";
import thumbnailDaily from "../../assets/thumbnail_daily.png";
import thumbnailDefault from "../../assets/thumbnail_default.png";
import thumbnailEnvironmentAlt from "../../assets/thumbnail_environment_alt.png";
import thumbnailEsArts from "../../assets/thumbnail_es_arts.png";
import thumbnailEsBuenasNoticias from "../../assets/thumbnail_es_buenas_noticias.png";
import thumbnailEsDaily from "../../assets/thumbnail_es_daily.png";
import thumbnailEsDelDomingo from "../../assets/thumbnail_es_del_domingo.png";
import thumbnailEsDocente from "../../assets/thumbnail_es_docente.png";
import thumbnailEurope from "../../assets/thumbnail_europe.png";
import thumbnailGlobal from "../../assets/thumbnail_global.png";
import thumbnailPolitics from "../../assets/thumbnail_politics.png";
import thumbnailSomethingGood from "../../assets/thumbnail_something_good.png";
import thumbnailSpotlight from "../../assets/thumbnail_spotlight.png";
import thumbnailUk from "../../assets/thumbnail_uk.png";
import thumbnailUkEducation from "../../assets/thumbnail_uk_education.png";
import thumbnailWorldAffairs from "../../assets/thumbnail_world_affairs.png";
interface ThumbnailProps {
  regionCode: string;
  newsletterName: string;
  className?: string;
}

/**
 * Maps newsletter thumbnails based on region code and newsletter name.
 * Based on the structure from marcus-playground.
 * Returns null if no matching thumbnail is found.
 */
export const Thumbnail = t0 => {
  "use memo";

  const $ = _c(11);
  const {
    regionCode,
    newsletterName,
    className
  } = t0;
  let t1;
  if ($[0] !== newsletterName || $[1] !== regionCode) {
    t1 = getThumbnailUrl(regionCode, newsletterName);
    $[0] = newsletterName;
    $[1] = regionCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const thumbnailUrl = t1;
  if (!thumbnailUrl) {
    return null;
  }
  const isPlaceholder = thumbnailUrl === thumbnailDefault.src;
  let t2;
  if ($[3] !== className || $[4] !== isPlaceholder) {
    t2 = clsx(className, {
      "bg-gray-50": isPlaceholder
    });
    $[3] = className;
    $[4] = isPlaceholder;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `url(${thumbnailUrl})`;
  let t4;
  if ($[6] !== t3) {
    t4 = {
      backgroundImage: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={t2} style={t4} />;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};

/**
 * Gets the thumbnail URL based on region code and newsletter name.
 * Maps based on the structure from marcus-playground/app/lib/newsletters.ts
 */
function getThumbnailUrl(regionCode: string, newsletterName: string): string | null {
  // Normalize region code to match marcus-playground region IDs
  const normalizedRegion = regionCode.toLowerCase();

  // Create a mapping key from region and newsletter name
  const key = `${normalizedRegion}:${newsletterName.toLowerCase().trim()}`;

  // Mapping based on marcus-playground structure
  const thumbnailMap: Record<string, string> = {
    // UK region
    "uk:the daily": thumbnailUk.src,
    "uk:education focus": thumbnailUkEducation.src,
    "uk:politics weekly": thumbnailPolitics.src,
    "uk:imagine": thumbnailEnvironmentAlt.src,
    "uk:world affairs briefing, from the uk": thumbnailWorldAffairs.src,
    "uk:something good": thumbnailSomethingGood.src,
    "uk:story spotlight": thumbnailSpotlight.src,
    "uk:the weekender": thumbnailDaily.src,
    "uk:global": thumbnailGlobal.src,
    "uk:global economy & business": thumbnailBusiness.src,
    "uk:europe newsletter": thumbnailEurope.src,
    "uk:the conversation ai": thumbnailAi.src,
    // Spain region
    "es:boletín diario": thumbnailEsDaily.src,
    "es:la conversación del domingo": thumbnailEsDelDomingo.src,
    "es:la conversación docente": thumbnailEsDocente.src,
    "es:¡buenas noticias!": thumbnailEsBuenasNoticias.src,
    "es:suplemento cultural": thumbnailEsArts.src,
    "es:europe newsletter": thumbnailEurope.src
  };
  return thumbnailMap[key] || null;
}